import { render } from "./CreateContractProposalPage.vue?vue&type=template&id=75b72e0b"
import script from "./CreateContractProposalPage.vue?vue&type=script&lang=js"
export * from "./CreateContractProposalPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__